import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from './utils';
import { useAuth } from '../context/AuthContext';

export const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

/* Polls the condo's weather every 5 minutes. status is 'idle' (no condo),
   'loading', 'ready', 'notFound' (weather not enabled for the condo) or
   'error'. After a failed refresh the last reading is kept but marked stale. */
export function useWeather(condoSlug) {
  const { getToken } = useAuth();
  const getTokenRef = useRef(getToken);
  getTokenRef.current = getToken;
  const [weather, setWeather] = useState(null);
  const [status, setStatus] = useState(condoSlug ? 'loading' : 'idle');

  useEffect(() => {
    let cancelled = false;
    setWeather(null);

    if (!condoSlug) {
      setStatus('idle');
      return undefined;
    }
    setStatus('loading');

    const load = async () => {
      try {
        const response = await axios.get(`${getApiBaseUrl()}/api/weather/${condoSlug}`, {
          headers: { Authorization: `Bearer ${getTokenRef.current()}` }
        });
        if (cancelled) return;
        setWeather(response.data.weather);
        setStatus('ready');
      } catch (err) {
        if (cancelled) return;
        if (err.response?.status === 404) {
          setStatus('notFound');
        } else {
          setWeather((current) => (current ? { ...current, stale: true } : current));
          setStatus((current) => (current === 'ready' ? 'ready' : 'error'));
        }
      }
    };

    load();
    const timer = setInterval(load, REFRESH_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [condoSlug]);

  return { weather, status };
}
